module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('upload-excel-component', {
    attrs: {
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.beforeUpload
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.panelTitle)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": ""
    }
  }, _vm._l((_vm.tableHeader), function(item) {
    return _c('el-table-column', {
      key: item,
      attrs: {
        "prop": item,
        "label": item
      }
    })
  }), 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a247a7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/excel/uploadExcel.vue
// module id = 1185
// module chunks = 2